// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__jdGE0","containerItemsCenter":"Skeleton_containerItemsCenter__2dQ6A"};